import { render, staticRenderFns } from "./NotificationPanelItemGroup.vue?vue&type=template&id=3f75f158&scoped=true"
import script from "./NotificationPanelItemGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPanelItemGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationPanelItemGroup.vue?vue&type=style&index=0&id=3f75f158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75f158",
  null
  
)

export default component.exports